import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => {
  return mergeStyleSets({
    text: {
      textDecoration: 'underline #000 dotted',
    }
  })
}
